import "./Footer.css";
import logo from "../../assets/logo.png";
function Footer() {
  return (
    <div className="Footer">
      <div className="FooterCopyright">
        <img src={logo} width={140} />
        <br/>
        <div>© 2025 Ame Network. All rights reserved.</div>
      </div>

      <div className="FooterList">
        <p>RESOURCE</p>

        <ul>
          <li>
            <a
              href="https://github.com/AmeNetwork/ame-component"
              target="_blank"
            >
              Ame Component
            </a>
          </li>
          <li>
            <a href="https://github.com/AmeNetwork/ame-sdk" target="_blank">
              Ame SDK
            </a>
          </li>
          <li>
            <a href="https://scan.ame.network/" target="_blank">
              Ame Scan
            </a>
          </li>
          <li>
            <a href="https://eips.ethereum.org/EIPS/eip-7654" target="_blank">
              EIP7654
            </a>
          </li>
          <li>
            <a href="https://eips.ethereum.org/EIPS/eip-7566" target="_blank">
              EIP7566
            </a>
          </li>
          <li>
            <a
              href="https://github.com/AmeNetwork/Model-Smart-Contract-Protocol"
              target="_blank"
            >
              MSCP
            </a>
          </li>
          <li>
            <a href="https://github.com/AmeNetwork/aser" target="_blank">
              Aser Agent
            </a>
          </li>
        </ul>
      </div>
      <div className="FooterList">
        <p>LEARN</p>
        <ul>
          <li>
            <a href="https://docs.ame.network/introduction" target="_blank">
              Documentation
            </a>
          </li>
          <li>
            <a href="https://github.com/AmeNetwork" target="_blank">
              Github
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@amenetwork" target="_blank">
              Youtube
            </a>
          </li>
          <li>
            <a href="https://x.com/0xAmeNetwork" target="_blank">
              X
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
export default Footer;
